module.exports = __webpack_public_path__ + "c533065822669c0b71e6a92dc99bac6a.pdf";